import type { Page } from 'src/types';

import { type AnalyticsState, MAIN_PAGE } from '../types';

export interface PageState {
  currentPage: Page;
}

export const pageReducer = (
  state: AnalyticsState,
  props: PageState,
): AnalyticsState => ({
  ...state,
  currentPage: MAIN_PAGE[props.currentPage],
});
